module.exports = __webpack_public_path__ + "img/wenzi4.031d807e.svg";